/**
 * zCRM's browser store. Atomic CRM keeps its settings (deal stages, deal types…) in the store
 * and falls back to its own demo defaults until they load, so a returning visitor or a quick
 * click could see "Copywriting" as a deal type. zCRM's settings are static (crmConfig.ts), so
 * they are written into the store before the first render, every time the app starts.
 */
import { localStorageStore, memoryStore, type Store } from "ra-core";

import { CONFIGURATION_STORE_KEY } from "../../root/ConfigurationContext";
import { zcrmConfiguration } from "./dataProvider";

const withZcrmConfiguration = (store: Store): Store => {
  store.setItem(CONFIGURATION_STORE_KEY, zcrmConfiguration);
  return store;
};

/** The live app's store: kept in localStorage, under zCRM's own key. */
export const createZcrmStore = (): Store =>
  withZcrmConfiguration(localStorageStore(undefined, "zCRM"));

/** The demo's store: in memory, like its data. */
export const createZcrmMemoryStore = (): Store =>
  withZcrmConfiguration(memoryStore());
